<template>
  <iRow class="side-nav" height="fill" overflow="scroll">
    <iMenu
      orientation="vertical"
      :active-item="activeStoryItem"
      :items="sideNavStories"
      :menu-item-style-overrides="myStyleOverrides"
    />
  </iRow>
</template>

<script>
import { mapState } from "pinia";
import {
  PAGE_STORIES,
  PAGE_STORIES_SYNDICATION,
  PAGE_STORIES_REQUIRES_APPROVAL,
  SIDE_NAV_STYLE_OVERRIDES,
} from "@/constants/nav-constants";
import { useGeneralStore } from "%/stores/general-store";
import { useFeatureStore } from "%/stores/feature-store";
export default {
  name: "MyStoriesSideNav",
  props: {
    activeItem: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useGeneralStore, [
      "orgId",
    ]),
    myStyleOverrides() {
      return SIDE_NAV_STYLE_OVERRIDES;
    },
    isSyndicationMarketplaceFeatureEnabled() {
      return useFeatureStore().isFeatureEnabled("syndicationMarketplace");
    },
    sideNavStories() {
      const menuItems = [
        {
          name: PAGE_STORIES,
          label: "My Stories",
          actionValue: "/stories",
          icon: "file-lines",
        },
      ];

      if (this.isSyndicationMarketplaceFeatureEnabled) {
        menuItems.push({
          name: PAGE_STORIES_SYNDICATION,
          label: "Syndication",
          actionValue: "/stories/syndication",
          icon: "share-nodes",
          subItems: [
            {
              name: PAGE_STORIES_REQUIRES_APPROVAL,
              label: "Requires Approval",
              actionValue: "/stories/syndication/approval",
            },
          ],
        });
      }
      return menuItems;
    },
    activeStoryItem() {
      return this.activeItem;
    },
  },
};
</script>
